import { render } from "./NewSiteComponent.vue?vue&type=template&id=8d78e518&scoped=true"
import script from "./NewSiteComponent.vue?vue&type=script&lang=js"
export * from "./NewSiteComponent.vue?vue&type=script&lang=js"

import "./NewSiteComponent.vue?vue&type=style&index=0&id=8d78e518&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d78e518"]])

export default __exports__